import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Qs from "qs";

Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export function pushInterceptor(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      store.dispatch("loader/toggleShow", true);
      config.paramsSerializer = (params) => {
        return Qs.stringify(params, {
          arrayFormat: "brackets",
          encode: false,
        });
      };

      config.headers.Authorization =
        "Bearer " + store.getters["user/accessToken"];
      config.headers.Accept = "application/json";
      return config;
    },
    (error) => {
      store.dispatch("loader/toggleShow", false);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      store.dispatch("loader/toggleShow", false);
      return response;
    },
    (error) => {
      const originalRequest = error.config;

      let tokenRefreshNeeded =
        error.response.status === 401 &&
        error.response.config.url.indexOf("api/v1/login") === -1 &&
        error.response.config.url.indexOf("api/v1/logout") === -1 &&
        error.response.config.url.indexOf("api/v1/refresh") === -1;

      if (!tokenRefreshNeeded) {
        store.dispatch("loader/toggleShow", false);
        handleError(error);
        return Promise.reject(error);
      }

      return new Promise((resolve, reject) => {
        store
          .dispatch("user/refresh")
          .then(() => {
            if (originalRequest.url.indexOf("api/v1/userinfo") === -1) {
              store.dispatch("user/userinfo");
            }
            store.dispatch("loader/toggleShow", false);
            resolve(axios(originalRequest));
          })
          .catch((error) => {
            store.dispatch("loader/toggleShow", false);
            reject(error);
          });
      });
    }
  );
}

function handleError(error) {
  if (error.response.status === 422) {
    let text = "";
    for (const key in error.response.data.errors) {
      if (Object.hasOwnProperty.call(error.response.data.errors, key)) {
        const element = error.response.data.errors[key];

        for (let index = 0; index < element.length; index++) {
          text += element[index] + " ";
        }
      }
    }
    Vue.swal({ title: "Napaka", text, type: "warning" });
    return;
  }
  if (error.response.status === 500) {
    Vue.swal({
      title: "Prišlo je do napake. Prosim, kontaktirajte administratorja",
      type: "error"
    });
  }
}
